import "./cash_activity.scss";

let cashActivityComponent = {
  restrict: "E",
  bindings: {},
};

export default cashActivityComponent;



// WEBPACK FOOTER //
// ./client/app/components/cash_activity/cash_activity.component.js